export enum ViewTypeEnum {

  DESKTOP,
  MOBILE,
  TABLET
}
